import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { VALIDATION_MESSAGE } from 'src/app/components/shared/shared-constants';
import { SpecialCharacters } from 'src/app/core/enums/special-characters.enum';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { TEXT } from './add-route.constants';

@Component({
  selector: 'app-add-route',
  templateUrl: './add-route.component.html',
  styleUrls: ['./add-route.component.scss'],
  standalone: false,
})
export class AddRouteComponent implements OnInit {
  addRouteForm!: FormGroup;
  enableSubmitButton = false;

  readonly BUTTON_TYPES = BUTTON_TYPES;
  readonly REGEX = SpecialCharacters.ALPHABET_NUMBER_NO_SPACE;
  readonly CONSTANTS = { ...VALIDATION_MESSAGE, ...TEXT };

  constructor(
    private dialogRef: MatDialogRef<AddRouteComponent>,
    public readonly commonUtils: CommonUtils,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.addRouteForm = this.fb.group({
      route: ['', Validators.compose([Validators.required])],
    });
  }

  onAccept(): void {
    this.dialogRef.close(this.addRouteForm.getRawValue());
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
